<template>
  <BaseModal
    :modal-name="name"
    max-width="max-w-2xl"
    :hide-overflow="false"
    @close="onClickClose"
  >
    <p
      class="text-center text-xl font-medium leading-[42px] tracking-tight text-darkestGray"
    >
      Badania dodane do koszyka zostaną usunięte z koszyka
    </p>
    <p
      class="mt-5 text-center text-sm leading-6 tracking-tight text-darkestGray"
    >
      Po dodaniu badań wysyłkowych badania realizowane w Punkcie Pobrań zostaną
      usunięte z koszyka. <strong>Czy chcesz kontynuować?</strong>
    </p>

    <div
      class="mt-5 flex grid-cols-2 flex-col-reverse gap-x-5 text-center sm:grid"
    >
      <BaseButton theme="link" @click="onClickClose"> Anuluj </BaseButton>
      <BaseButton theme="default" @click="onClickClearItems">
        Potwierdź
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import { useModalsStore } from '~/stores/modals'
import { useCartStore } from '~/stores/cart'

const name = 'clearCart'

const { t } = useI18n()

const modalStore = useModalsStore()
const cartStore = useCartStore()

const onClickClearItems = () => {
  cartStore.clearItems()
  modalStore.close(name)

  // Dispatch custom event to notify that cart was cleared
  window.dispatchEvent(
    new CustomEvent('modal:action', {
      detail: {
        modalName: name,
        action: 'cleared',
      },
    })
  )
}

const onClickClose = () => {
  modalStore.close(name)

  // Dispatch event to notify that cart clearing was cancelled
  window.dispatchEvent(
    new CustomEvent('modal:action', {
      detail: {
        modalName: name,
        action: 'cancelled',
      },
    })
  )
}
</script>
